module.exports = __webpack_public_path__ + "img/down-arrow-white.f3ea5f91.svg";